export type MigrateStatus =
  | 'no change'
  | 'create'
  | 'update'
  | 'two-pass'
  | 'publish'
  | 'delete'
  | 'not found'
  | 'error'
  | 'ignore';

export type DownloadStatus = 'cached' | 'downloaded' | 'error';
